
module.factory('Principal', function($q, $http, $state, $timeout, $interval,
                                     moment, Notifications, $window) {


    var _is_resolved = false,
        return_to = null,
        tickTock,
        expireDelay = moment.duration(4, 'hours'),
        tickInterval = moment.duration(5, 'minutes');

    function _getIdentity() {
        return $http.get('/api/session').then(function(response) {
            return response.data;
        });
    }

    var principal = {
        is_authenticated: false,
        is_anonymous: true,
        id: null,
        username: null,
        name: null,
        first_name: null,
        last_name: null,
        email: null,
        permissions: {},
        resolved: false,
        reset_required: false,
        update_required: false,
        uuid: null,
    };

    principal.resolve = function() {
        if (!_is_resolved) {
            return _getIdentity().then(function(identity) {
                principal.setIdentity(identity);
                _is_resolved = true;
                principal.resolved = true;
                if (identity.is_authenticated) {
                    startTick();
                }
                return $timeout(500).then(function() {
                    return principal;
                });
            });
        } else {
            return $q.when(principal);
        }
    };

    principal.setIdentity = function(identity) {
        principal.is_authenticated = identity.is_authenticated;
        principal.is_anonymous = identity.is_anonymous;
        principal.id = identity.id;
        principal.name = identity.name;
        principal.username = identity.username;
        principal.first_name = identity.first_name;
        principal.last_name = identity.last_name;
        principal.email = identity.email;
        principal.reset_required = identity.reset_required;
        principal.update_required = identity.update_required;
        angular.copy(identity.permissions, principal.permissions || {});
        principal.program_count = identity.program_count;
        principal.program_id = identity.program_id;
        principal.program_slug = identity.program_slug;
        principal.new_announcements = identity.new_announcements;
        principal.uuid = identity.uuid;

        if ($window.trackJs) {
            $window.trackJs.configure({
                userId: [identity.id, identity.name].join('-'),
            });
        }
    };

    principal.logout = function() {
        return $http.delete('/api/session').then(function(response) {
            stopTick();
            principal.setIdentity(response.data);
            return principal;
        });
    };

    principal.login = function(username, password) {
        return sendLogin({
            username: username,
            password: password,
        });
    };

    principal.tokenLogin = function(token, type) {
        type = type || token;
        return sendLogin({
            token: token,
            type: type,
        });
    };

    principal.slackLogin = function(code, state) {
        if (!code) return $q.reject('No code present');
        return sendLogin({
            type: 'slack',
            code: code,
            state: state,
        });
    }

    principal.resetPassword = function(email) {
        return $http.post('/api/session/reset', {email: email});
    };

    function sendLogin(data) {
        return $http.post('/api/session', data)
            .then(function(response) {
                _is_resolved = true;
                principal.setIdentity(response.data);
                principal.resolved = true;
                principal.expired = false;
                startTick();
                return principal;
            }, function(response) {
                return $q.reject(response.data.message);
            });
    }

    principal.changePassword = function(password) {
        return principal.update({password: password});
    };

    principal.getAPIToken = function() {
        return $http.post('/api/session/token').then(function(response) {
            return response.data.token;
        });
    }

    principal.update = function(data) {
        return $http.patch('/api/session', data)
            .then(function(response) {
                principal.setIdentity(response.data);
                return principal;
            });
    };


    principal.impersonate = function(id) {
        return $http.post('/api/session/impersonate', {user_id: id})
            .then(function(response) {
                principal.setIdentity(response.data);
                return principal;
            })
    };

    principal.$checkPermissions = function(permission) {
        return this.resolve().then(function(principal) {
            if (principal.permissions && principal.permissions[permission]) {
                return $q.when(true);
            } else {
                return $q.reject({
                    reason: 'unauthorized',
                    permission: permission,
                })
            }
        });
    };

    principal.doReturn = function() {
        if (this.returner) {
            this.returner();
            return;
        }
        $state.go('home', {});
    }

    principal.resetExpire = function() {
        this.expires_at = moment().add(expireDelay);
    }

    principal.expire = function() {
        $timeout(function() {
            this.returner = $state.go.bind($state, $state.current.name, $state.params);
            this.expired = true;
            stopTick()
            $state.go('login');
        });
    }

    function tick() {
        if (principal.is_authenticated && !principal.expired) {
            if (moment().isAfter(principal.expires_at)) {
                principal.expire();
            }
        }
    }

    function startTick() {
        $interval.cancel(tickTock);
        tickTock = $interval(tick, tickInterval.asMilliseconds());
    }

    function stopTick() {
        $interval.cancel(tickTock);
    }

    return principal;
});


module.directive('permissionContext', function() {
    return {
        restrict: 'A',
        controller: function($scope, $attrs) {
            this.permissions = $scope.$eval($attrs.permissionContext);
        }
    };
});

module.factory('$checkPermissions', function($q, Principal) {
    return function(permission, permissions) {
        permissions = permissions || Principal.permissions;
        if (permissions[permission]) {
            return $q.when(true);
        } else {
            return $q.reject({
                reason: 'unauthorized',
                permission: permission,
            });
        }
    };
});


function createIfPermissionDirective(Principal, checkPerm) {
    return {
        restrict: 'A',
        transclude: 'element',
        priority: 1200,
        terminal: true,
        require: '^?permissionContext',
        compile: function(tElement, tAttrs, transclude) {
            return function(scope, iElement, iAttrs, ctrl) {
                var permissions = ctrl ?
                    ctrl.permissions :
                    Principal.permissions;

                if (checkPerm(permissions, iAttrs)  ) {
                     transclude(scope, function(clone) {
                        return iElement.after(clone);
                    });
                }
            };
        },
    };
}



module.directive('ifPermission', function(Principal) {
    return createIfPermissionDirective(Principal, function(permissions, attrs) {
        return permissions[attrs.ifPermission];
    });
});

module.directive('ifAnyPermission', function(Principal) {
    return createIfPermissionDirective(Principal, function(permissions, attrs) {
        var i, perms = attrs.ifAnyPermission.split(',');
        for (i = 0; i < perms.length; i++) {
            if (permissions[perms[i]]) {
                return true;
            }
        }
        return false;
    });
});

module.directive('ifAllPermissions', function(Principal) {
    return createIfPermissionDirective(Principal, function(permissions, attrs) {
        var i, perms = attrs.ifAllPermissions.split(',');
        for (i = 0; i < perms.length; i++) {
            if (!permissions[perms[i]]) {
                return false;
            }
        }
        return true;
    });
});